(function () {
  var syncQueued = false;

  function hydratePostImage(image) {
    var source = image.getAttribute('data-instafeed-src');
    var current = image.getAttribute('src') || '';

    if (source && (!current || current.indexOf('/placeholder.png') !== -1)) {
      image.setAttribute('src', source);
    }
  }

  function normalizePostMedia(item) {
    var media = null;

    for (var i = 0; i < item.children.length; i += 1) {
      var child = item.children[i];
      if (
        child.tagName === 'VIDEO' ||
        (child.tagName === 'IMG' && child.classList.contains('instafeed-lazy-image'))
      ) {
        media = child;
        break;
      }
    }

    if (!media) return;

    media.style.setProperty('top', '0', 'important');
    media.style.setProperty('right', '0', 'important');
    media.style.setProperty('bottom', '0', 'important');
    media.style.setProperty('left', '0', 'important');
    media.style.setProperty('width', '100%', 'important');
    media.style.setProperty('height', '100%', 'important');
    media.style.setProperty('object-fit', 'cover', 'important');
    media.style.setProperty('object-position', 'center', 'important');
    media.style.setProperty('transform', 'none', 'important');

    if (media.tagName === 'IMG') hydratePostImage(media);
  }

  function syncInstafeed() {
    var feed = document.getElementById('insta-feed');
    if (!feed) return false;

    var section = feed.closest('.shopify-section');
    if (section) section.classList.add('aspyr-instafeed-section');

    var items = feed.querySelectorAll('.instafeed-new-layout-item');
    for (var i = 0; i < items.length; i += 1) {
      normalizePostMedia(items[i]);
    }

    return true;
  }

  function queueSync() {
    if (syncQueued) return;
    syncQueued = true;

    window.requestAnimationFrame(function () {
      syncQueued = false;
      syncInstafeed();
    });
  }

  function init() {
    syncInstafeed();

    var observer = new MutationObserver(function () {
      queueSync();
    });

    observer.observe(document.documentElement, { childList: true, subtree: true });

    window.addEventListener('load', queueSync, { once: true });
    window.setTimeout(queueSync, 800);
    window.setTimeout(queueSync, 2000);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();
